const alert = state => state.alert
const loading = state => state.loading

export default {
  alert,
  loading
};
